import {StoreType} from '../../../types/sharedTypes';

export const allRemissionsSelector = (state: StoreType) => {
  return state.remissionReducer.remissionResult;
}
